import {IsArray} from 'class-validator';
import {ValidateNested} from 'class-validator';
import {ExcelStyleGroupTitleAndTextValueDto} from './excel-styles.dto';
import {Type} from 'class-transformer';
import 'reflect-metadata';

/**
 * 사용량 엑셀 Dto
 * @public
 */
export class ExcelUsageDto {
  /**
   * 년, 월, 일 카테고리와 그에 대한 값 리스트
   */
  @IsArray()
  @ValidateNested({each: true})
  @Type(() => ExcelStyleGroupTitleAndTextValueDto)
  usageList: ExcelStyleGroupTitleAndTextValueDto[];
}
